import { PROVIDERS_MAP, ITERATION_TYPE } from 'common/constants/constants';
import { getColor } from 'common/constants/_colors';
import { Separator } from 'components/base/layout-components';
import SnackBarMessage from 'components/Message';
import _ from 'lodash';
import { usePMIterations } from './hooks/usePMIterations';
import Header from './components/Header';
import Selection from './components/Selection';
import EmptyState from './components/EmptyState';
import React from 'react';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';
import useProviderEntities from 'common/fetchHooks/pmProvider/useProviderEntities';
import { DeviationError } from 'common/constants/error-types';

const PMIterations = ({
  selectedTeam,
  toggleSnackBar,
  projects,
  updateProject,
  isTeamLicense,
  sensorAuth,
  getIterations,
  retentionDays,
  DateSelectionChanged,
  hasIterations,
  pmToolConfig
}) => {
  const { data: providerEntities } = useProviderEntities(
    sensorAuth?.sensor_id,
    PROVIDERS_MAP[sensorAuth?.sensor_name?.toLowerCase()]?.entity_name_plural
  );
  const { getSettingOrDefinitionValue } = useSettingsService();
  const selectedTeamProjectId = _.get(selectedTeam, 'project_id');
  const selectedTeamName = _.get(selectedTeam, 'name');
  const selectedTeamId = _.get(selectedTeam, 'id');
  const isTeamPMConfigurationEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.teamPMConfigurationEnabled
  });
  const {
    errors,
    selectedProviderIds,
    projectsFormatedForDropdown,
    filteredIterations,
    iterations,
    setRegexTerm,
    regexTerm,
    isCustomIterations,
    isSaveEnabled,
    onChangeIterationsType,
    onIterationSelection,
    onSaveChangesClick,
    onTeamProjectSelection,
    isLoadingIterations,
    selectedFilters,
    setSelectedFilters,
    cadence,
    setCadence,
    selectedFiltersOrigin,
    onChangeCadence,
    isOnSaveAction,
    setIsOnSaveAction
  } = usePMIterations({
    selectedTeamProjectId,
    projects,
    updateProject,
    selectedTeamId,
    isTeamLicense,
    providerEntities,
    sensorAuth,
    getIterations,
    pmToolConfig,
    retentionDays,
    DateSelectionChanged,
    isTeamPMConfigurationEnabled
  });

  const selectedIterations = filteredIterations.filter(
    ({ isSelected }) => isSelected
  ).length;
  const iterationsType = isCustomIterations
    ? ITERATION_TYPE.CUSTOM
    : ITERATION_TYPE.IMPORT;

  const onSave = async () => {
    try {
      setIsOnSaveAction(true);
      await onSaveChangesClick();
      toggleSnackBar({
        message: (
          <SnackBarMessage message='Success! your Pulse view and reports data will be updated soon' />
        ),
        variant: 'success'
      });
    } catch (e) {
      const message =
        e instanceof DeviationError
          ? e.message
          : 'Failed to update settings, please try again later';
      toggleSnackBar({
        message: <SnackBarMessage message={message} />,
        variant: 'error'
      });
    } finally {
      setIsOnSaveAction(false);
    }
  };

  return (
    <>
      <Header
        selectedTeamName={selectedTeamName}
        projectsFormatedForDropdown={projectsFormatedForDropdown}
        selectedProviderIds={selectedProviderIds}
        itrationsType={iterationsType}
        selectedIterations={selectedIterations}
        isSaveEnabled={isSaveEnabled}
        onSave={onSave}
        selectedFilters={selectedFilters}
        pmToolConfig={pmToolConfig}
      />
      <Separator
        width='100%'
        height='1px'
        color={getColor('catskillWhite')}
        margin='1rem 0 2rem 0'
      />

      {!projectsFormatedForDropdown.length && !isTeamLicense ? (
        <EmptyState pmToolConfig={pmToolConfig} />
      ) : (
        <Selection
          onTeamProjectSelection={onTeamProjectSelection}
          projectsFormatedForDropdown={projectsFormatedForDropdown}
          selectedProviderIds={selectedProviderIds}
          itrationsType={iterationsType}
          onChangeIterationsType={onChangeIterationsType}
          iterations={iterations}
          setRegexTerm={setRegexTerm}
          regexTerm={regexTerm}
          errors={errors}
          pmToolConfig={pmToolConfig}
          isLoadingIterations={isLoadingIterations}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          isTeamPMConfigurationEnabled={isTeamPMConfigurationEnabled}
          providerEntities={providerEntities}
          selectedFiltersOrigin={selectedFiltersOrigin}
          cadence={cadence}
          setCadence={setCadence}
          onChangeCadence={onChangeCadence}
          filteredIterations={filteredIterations}
          onIterationSelection={onIterationSelection}
          hasIterations={hasIterations}
          isOnSaveAction={isOnSaveAction}
        />
      )}
    </>
  );
};
export default PMIterations;
